import "./Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <div>
        <h2>Cervica</h2>
        <p>כרית ארגונומית מחומר ויסקו איכותי, לשינה על הגב ועל הצד.</p>
      </div>

      <div>
        <h4>ניווט</h4>
        <Link to="/">בית</Link>
        <Link to="/product">המוצר</Link>
        <Link to="/doctor">אודות</Link>
        <Link to="/contact">צור קשר</Link>
      </div>

      <div>
        <h4>יצירת קשר</h4>

        <p>
          טלפון:{" "}
          <a href="tel:+972522418085">
            <bdi dir="ltr">052-241-8085</bdi>
          </a>
        </p>

        <p>
          אימייל:{" "}
          <a href="mailto:adnan3@bezeqint.net">
            <bdi dir="ltr">adnan3@bezeqint.net</bdi>
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
